import { render, staticRenderFns } from "./CardTextoFinal.vue?vue&type=template&id=7c0aa194&scoped=true&"
import script from "./CardTextoFinal.vue?vue&type=script&lang=js&"
export * from "./CardTextoFinal.vue?vue&type=script&lang=js&"
import style0 from "./CardTextoFinal.vue?vue&type=style&index=0&id=7c0aa194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0aa194",
  null
  
)

export default component.exports